import { NoDataComponent, TableVirtualized } from '@repo/ui';
import { GetSuspectedManipulationUseCaseInterface } from 'domain/usecases';
import { makeSuspectedActivitiesColumns } from 'presentation/app/modules/Reports/common/columns/activities/suspected-location-manipulation';
import { useMemo } from 'react';
import '../table.scss';

interface Props {
  data: GetSuspectedManipulationUseCaseInterface.Result['data'];
  isLoading: boolean;
  hasFetchedData: boolean;
}

export const SuspectedActivitiesTable = ({
  data,
  isLoading,
  hasFetchedData,
}: Props) => {
  const columns = useMemo(() => makeSuspectedActivitiesColumns(), []);

  const hasData = data.length > 0;
  const showNoDataComponent = !hasData && hasFetchedData && !isLoading;

  if (showNoDataComponent) {
    return (
      <div className="p-4">
        <NoDataComponent />
      </div>
    );
  }

  return (
    <div className="suspected-location-table">
      <TableVirtualized data={data} columns={columns} />
    </div>
  );
};
